module.exports = __webpack_public_path__ + "static/media/twitter.12d8b0e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/twitter.svg
// module id = 98
// module chunks = 0